import { Component, Input } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import * as _ from 'lodash';
import { BkgImageDirective } from '../../directives/bkgimage.directive';
import { IDocumentMedia, IMediaView } from '../../models/media.interface';
import { MeService } from '../../services/me.service';
import { DlgImageViewComponent } from '../dlg-image-view/dlg-image-view.component';

@Component({
  selector: 'ui-image-list',
  templateUrl: './ui-image-list.component.html',
  styleUrls: ['./ui-image-list.component.css'],
  imports: [BkgImageDirective, MatIconButton, MatIcon]
})
export class UiImageListComponent {

  @Input('media')
  public set media(media: IDocumentMedia) {
    this._media = media;
    this.imageIdx = 0;
  }
  public get media(): IDocumentMedia | null { return this._media ?? null; }
  private _media?: IDocumentMedia;

  constructor(private me: MeService) { }

  ////////////////////////////////////////////
  // images

  public get images(): Array<IMediaView> { return this.media?.images ?? []; }
  public get numImages(): number { return this.images.length; }
  public get imageNavigatorVisible(): boolean { return this.numImages > 1; }
  public imageIdx = 0;
  public get currentImage(): IMediaView | undefined { return this.numImages > 0 ? this.images[this.imageIdx] : undefined; }

  public get canImageNext() { return this.imageIdx < this.numImages - 1; }
  public get btnImageNext() { return this.canImageNext ? 'visible' : 'hidden'; }

  public onImageNext() {

    if (this.canImageNext)
      this.imageIdx += 1;

  }

  public get canImagePrev() { return this.imageIdx > 0; }
  public get btnImagePrev() { return this.canImagePrev ? 'visible' : 'hidden'; }

  public onImagePrev() {

    if (this.canImagePrev)
      this.imageIdx -= 1;

  }

  public onImage(index: number) {

    this.imageIdx = index;

  }

  public get imageHasLink(): boolean {
    return this.currentImage?.link ? true : false;
  }

  public onImageClick() {

    if (!this.currentImage)
      return;

    // get current media
    var media = this.currentImage;
    if (media?.link) {

      // url to open
      var url: string | null = null;

      // switch link type
      switch (_.toLower(media.link.type)) {

        case 'url':
          url = media.link.data;
          break;

        case 'youtube':
          url = `https://www.youtube.com/embed/${media.link.data}?rel=0`;
          break;

        default:
          return;
      }

      if (url)
        window.open(url, 'assistant.link');
    }
    else {

      // toggle single / multiple
      // this._singleImage = !this._singleImage;
      this.me.openFullscreenDialog(DlgImageViewComponent, 'dlg-image', this.currentImage);

    }
  }

  public cancelClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
}
